<template>
  <div class="p-[30px] hidden lg:block sidebar">
    <div class="sticky top-[108px]">
      <!-- <div class=" bg-white border border-border rounded-md lg:mb-5 mb-4 hidden lg:block" v-if="(state.opt_type == 'general' && state.enroll_option == 'individual')">
        <div class="p-4 flex items-start justify-start gap-4">
          <span
            class="w-[50px] h-[50px] bg-primaryLight border border-border flex rounded-md items-center justify-center shrink-0">
            <img src="@/assets/images/info.svg" alt="info">
          </span>
          <div>
            <p class="content" v-if="state.opt_type == 'general' && state.enroll_option == 'individual'">
              This application is to enroll as an individual, which means that you are not
              affiliated
              with
              a company that partners with us.
            </p>
            <p class="content" v-if="state.opt_type == 'general' && state.enroll_option == 'individual'">
              To inquire if your company is a partner with U.S. Legal, please email <a href="info@uslegalservices.net"
                class="text-blackPrimary">info@uslegalservices.net</a>
              or contact our Member
              Care
              Team at (800) 356-LAWS (5297).
            </p>
            <p class="content" v-if="state.opt_type == 'general' && state.enroll_option == 'individual'">
              Currently, individual enrollments are only accepted for the CDL Defender.
            </p>
          </div>
        </div>
      </div> -->
      <div v-if="disp_err_msg">
        <h5 class="text-red-500 font-medium">Company is not set up as a dedicated page.</h5>
      </div>
      <SelectedPlanInfo :state="state" v-if="state.disp_enroll_section"
        :planName="selectedPlanName" :monthlyCost="selectedPlanMonthlyCost"
        :proratedPremium="selectedPlanProratedPremium" :serviceFees="selectedPlanServiceFees"
        :finalAmount="selectedPlanFinalAmount" />
      <PolicyInfo :state="state" v-if="state.disp_enroll_section" />
    </div>
  </div>
</template>

<script>
import SelectedPlanInfo from "./SelectedPlanInfo.vue";
import PolicyInfo from "./PolicyInfo.vue";

export default {
  name: "SidebarInfo",
  components: {
    SelectedPlanInfo,
    PolicyInfo,
  },
  props: {
    state: Object,
  },
  data() {
    return {
      selectedCompany: null,
      selectedPlanName: "CDL Defender and Family Defender",
      selectedPlanMonthlyCost: "$25.00",
      selectedPlanProratedPremium: "$7.26",
      selectedPlanServiceFees: "$2.00",
      selectedPlanFinalAmount: "$34.26",
    };
  }
};
</script>

<style scoped>
.sidebar {
  background-color: #edf1f8;
  /* Replace with your desired color */
}
</style>
